import { useState } from "react";
import { useSelector } from "react-redux";
import BlockedScreen from "../components/BlockedScreen/BlockedScreen";
import { useAuth } from "../hooks/useAuth";
import { selectIsLoggingOut } from "../reduxSlices/globalFlagsSlice";
import "./Pages.css";
import Translatable from "../components/Translatable/Translatable";

const BlockedPage = () => {
  const { doLogout } = useAuth();
  const isLoggingOut = useSelector(selectIsLoggingOut);
  const [isLeaving, setIsLeaving] = useState(false);

  const handleVolverAlInicio = () => {
    // Ocultar de inmediato para no re-renderizar /bloqueo con el mensaje por defecto
    // mientras doLogout limpia el estado de Redux y completa el redirect de MSAL.
    setIsLeaving(true);
    void doLogout();
  };

  if (isLeaving || isLoggingOut) {
    return null;
  }

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <BlockedScreen />
      <button onClick={handleVolverAlInicio} className="back-to-login-btn">
        <Translatable as="span" capitalize>Volver al inicio</Translatable>
      </button>
    </div>
  );
};

export default BlockedPage;
